export default "__VITE_ASSET__BOM0c_vh__"